/**
 * How long server-seeded TanStack Query entries for portal-shell reads
 * (`/api/auth/me`, billing entitlements) stay fresh on the client. Matches
 * {@link useActiveOrganization}'s window so a future shell prefetch does not
 * immediately refetch on mount.
 */
export const PORTAL_SHELL_SERVER_SEED_STALE_TIME_MS = 60_000;
